import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';

const OptionSwitcher = ({ options, onSelect, size, selected }) => {
  const [selectedOption, setSelectedOption] = useState(selected ?? options[0].value);

  useEffect(() => {
    setSelectedOption(selected);
  }, [selected]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (onSelect) {
      onSelect(option);
    }
  };

  return (
    <div className="keduall-tab-panel tab-panel-container p-2 flex flex-nowrap md:flex-nowrap overflow-x-auto">
      {options.map((option) => (
        <Button
          key={option}
          label={option.label}
          text={selectedOption !== option.value}
          onClick={() => handleOptionClick(option.value)}
          size={size}
          className={`w-1/2 md:w-auto tab-label-button keduall-typography heading-h5-semibold-600 ${selectedOption === option.value ? 'active-button' : 'inactive-button'}`}
        />
      ))}
    </div>
  );
};

export default OptionSwitcher;
